module.exports = __webpack_public_path__ + "img/touXiang3.0ae9c1a1.png";